import {
  IRuleGroup,
  IRuleItem,
} from '@components/mapping-panel/components/RuleBuilder/RuleGroup/typed';
import { mappedEventDimensionType } from '@src/common/constant/enum';

export const createFilter = (type: string, value: string, andIndex: number) => {
  return {
    field: type,
    key: type,
    op: 'eq',
    value: value,
    display: value,
    originalField: type,
    _order: andIndex,
  };
};

export const createFiltersGroup = (
  eventName?: IRuleGroup['eventName'],
  tagKey?: IRuleItem['tagKey'],
  tagValue?: IRuleItem['tagValue']['value'],
) => {
  const filters: any[] = [];
  const l = filters.length;
  if (eventName) {
    const eventFilter = [createFilter(mappedEventDimensionType.all_event_name, eventName, l)];
    filters.push(eventFilter);
  }
  if (tagKey) {
    const tagKeyFilter = [createFilter(mappedEventDimensionType.merged_event_tag_key, tagKey, l)];
    filters.push(tagKeyFilter);
  }
  if (tagValue) {
    const tagValueFilter = [
      createFilter(mappedEventDimensionType.merged_event_tag_value, tagValue, l),
    ];
    filters.push(tagValueFilter);
  }
  return filters;
};

export const createFilterWithGlobalFilter = ({
  filters = [],
  type = mappedEventDimensionType.merged_event_tag_key,
  value,
}: {
  filters?: any[][];
  type?: string;
  value: string;
}) => {
  const l = filters.length;
  return [...filters, [createFilter(type, value, l)]];
};
